import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CourseService } from '../services/course.service';
import { SharedModule } from '@app/shared/shared.module';
import { Utilities } from '@app/core/utils/utilities';

@Component({
    selector: 'app-course-confirmation-popup',
    imports: [CommonModule, SharedModule],
    templateUrl: './course-confirmation-popup.component.html',
    styleUrl: './course-confirmation-popup.component.css'
})
export class CourseConfirmationPopupComponent {
  dialogRef = inject(MatDialogRef<CourseConfirmationPopupComponent>);
  details = inject(MAT_DIALOG_DATA);
  courseDataService = inject(CourseService);
  util = inject(Utilities);
  successMsg: string = '' ;
  status!: string;
  name!: string;
  level!: 'Course' | 'Instance';
  institutionDetails: any;
  fastlaneChecked: boolean = false;

  ngOnInit(): void {
    this.fetchCourseRelatedDetails();
  }

  fetchCourseRelatedDetails() {
    this.level = this.details.level;
    this.status = this.details.status?.toLowerCase() === 'archived' ? 'Unarchive' : 'Archive';
    if(this.level === 'Course') this.name = this.details.courseName;
    else this.name = this.details.courseInstanceTitle;
    this.institutionDetails = JSON.parse(this.util.institutionDetails());
  }

  updatestatus() {
    const updatedStatus = this.status?.toLowerCase()?.replace('una', 'unA');
    if(this.level === 'Course')
      this.updateCourseStatus(updatedStatus);
    else if(this.level === 'Instance')
      this.courseDataService.archiveOrUnarchiveCourseInstance(this.details.courseId, updatedStatus, this.details.courseInstanceId).subscribe(
        res => {
          if (res?.message === 'Successful response') {
            if (updatedStatus == 'unArchive')
              this.successMsg = "The course instance " + this.name + " has been successfully unarchived. To change the status to live, click on the course instance name and verify the information is correct and all mandatory fields are completed and then press save";
            else
              this.successMsg = "The course instance " + this.name + " has been successfully archived. Please search for 'Archived' status to view the archived course instance list";
            this.dialogRef.close(this.successMsg);
          }
        }
      )
  }

  updateCourseStatus(updatedStatus: any) {
    this.courseDataService.archiveOrUnarchiveCourse(this.details.courseId, updatedStatus).subscribe(
      res => {
        if (res?.message === 'Successful response') {
          if (updatedStatus == 'unArchive')
            this.successMsg = "The course " + this.name + " has been successfully unarchived. To change the status to live, click on the course name and verify the information is correct and all mandatory fields are completed and then press save";
          else
            this.successMsg = "The course " + this.name + " has been successfully archived. Please search for 'Archived' status to view the archived course list";
          this.dialogRef.close(this.successMsg);
        }
      }
    )
  }
}
